import Client from '../HttpClient';

const list = (processStatus) => {
	return Client.get('/api/online-order/order-list', { processStatus });
};

const find = (OnlineOrderId) => {
	return Client.get('/api/online-order/order-detail', { OnlineOrderId });
};

const panel = (orderNo) => {
	return Client.post('/api/online-order/panel-orders', { orderNo });
};

const place = (OnlineOrderId, OperatedBy) => {
	return Client.post('/api/online-order/place', { OnlineOrderId, OperatedBy });
};

const print = (payload) => {
	return Client.post('/api/online-order/order-prints', { payload });
};

const reject = (OnlineOrderId, OperatedBy, Reason) => {
	return Client.post('/api/online-order/reject', {
		OnlineOrderId,
		OperatedBy,
		Reason,
	});
};

const cancel = (OnlineOrderId, OperatedBy, Reason) => {
	return Client.post('/api/online-order/cancel', {
		OnlineOrderId,
		OperatedBy,
		Reason,
	});
};

const prepared = (OnlineOrderId, OperatedBy) => {
	return Client.post('/api/online-order/prepared', {
		OnlineOrderId,
		OperatedBy,
	});
};

const deliver = (OnlineOrderId, OperatedBy) => {
	return Client.post('/api/online-order/delivery', {
		OnlineOrderId,
		OperatedBy,
	});
};

const pickup = (OnlineOrderId, OperatedBy) => {
	return Client.post('/api/online-order/pick-up', {
		OnlineOrderId,
		OperatedBy,
	});
};

const completedDeliver = (orderSn, branchId, merchantId, receivingCode) => {
	return Client.post(
		`/gateway/eagle-portal/api/vs/online/order/${orderSn}/receive`,
		{
			branchId,
			merchantId,
			receivingCode,
		}
	);
};

export default {
	list,
	find,
	place,
	print,
	reject,
	cancel,
	panel,
	prepared,
	deliver,
	pickup,
	completedDeliver,
};
